export default __webpack_public_path__ + "static/media/banner-mobile-encerrado.3bf24e57.png";